import { AssignmentsAssignTo } from '../../../../../types/AssignmentsAssignTo';
import { useAssignmentGroups } from '../../../assignments/members/useAssignmentGroups';
import { AssignmentToType } from '../../../../../types/enums/AssignmentToType';
import { useSweepFieldsInfo } from '../../../../../sweep-fields/useSweepFieldsInfo';

export const useGetNameFromAssignTo = () => {
  const { crmOrgUsers } = useAssignmentGroups();
  const { assignmentGroups } = useAssignmentGroups();
  const { getLabelFromIdsWithObjectType } = useSweepFieldsInfo();

  const getGroupNameById = (groupId: string): string => {
    return assignmentGroups?.find((group) => group.id === groupId)?.name || '';
  };

  const getNameFromAssignTo = (assignTo: AssignmentsAssignTo) => {
    if (assignTo.type === AssignmentToType.User) {
      return crmOrgUsers?.find((user) => user.id === assignTo.id)?.name || '';
    }
    if (assignTo.type === AssignmentToType.Team) {
      // New structure: weightedGroups array
      if (assignTo.weightedGroups && assignTo.weightedGroups.length > 0) {
        const names = assignTo.weightedGroups
          .map((g) => g._name || getGroupNameById(g.groupId))
          .filter(Boolean);
        return names.join(', ');
      }
      // Old structure: single id
      return getGroupNameById(assignTo.id || '') || assignTo._name || '';
    }
    if (assignTo.type === AssignmentToType.Field) {
      if (assignTo.fieldMapping.fromField?.fieldIds) {
        return getLabelFromIdsWithObjectType(assignTo.fieldMapping.fromField.fieldIds).join('.');
      }
      return assignTo._name || '';
    }
    if (assignTo.type === AssignmentToType.Queue) {
      return assignTo._name || '';
    }

    return assignTo || '';
  };

  return { getNameFromAssignTo };
};
